import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

import { RffInput } from '@cast/shared-rff-ui';

export const NebiusGpuClusterSection = () => (
  <InlineWithDescription
    description={
      <ControlWithDescription label="GPU cluster">
        ID of the Nebius GPU cluster to use. GPU clusters connect GPU-enabled
        VMs with high-speed networking for multi-node GPU workloads.
      </ControlWithDescription>
    }
    controls={
      <RffInput
        name="gpuCluster"
        label="GPU cluster"
        inputProps={{
          placeholder: 'Enter GPU cluster ID',
        }}
        testId="gpu-cluster-input"
      />
    }
  />
);
